export default "__VITE_ASSET__ad72e5f8__"